import { Block } from 'baseui/block';
import { Button, KIND, SIZE } from 'baseui/button';
import get from 'lodash/get';
import { pure, compose } from 'recompose';
import { styled, useStyletron } from 'baseui';
import Papa from 'papaparse';
import React from 'react';
import ReactFileReader from 'react-file-reader';
import GridFilled from '@uber/icons/grid-filled';
import type { QuestionType } from '../../reducers';
import { prepareAnswer } from '../../utils/answer';
type ConnectedImportAnswersPropType = {
  questionId: string;
  question: QuestionType;
  updateQuestion: Function;
};
const Wrap = styled('div', {
  display: 'inline-block'
});
const ImportAnswers = ({
  questionId,
  question,
  updateQuestion
}: ConnectedImportAnswersPropType) => {
  const [css, theme] = useStyletron();
  return <Wrap>
      <ReactFileReader multipleFiles={false} fileTypes=".csv" handleFiles={files => {
      const file = get(files, 0);
      Papa.parse(file, {
        complete: result => {
          let answers = get(result, 'data') || [];
          answers = answers.map(importedAnswer => {
            const answerCopy = get(importedAnswer, 0);
            const noteOption = get(importedAnswer, 1);
            return {
              ...prepareAnswer(answerCopy, noteOption)
            };
          });
          const currentAnswers = get(question, 'answers');
          updateQuestion({
            ...question,
            answers: [...currentAnswers, ...answers]
          });
        }
      });
    }}>
        <Button onClick={e => {
        e.preventDefault();
      }} kind={KIND.secondary} size={SIZE.compact}>
          <GridFilled />
          <Block className={css({
          marginLeft: theme.sizing.scale200
        })}>
            Import answers
          </Block>
        </Button>
      </ReactFileReader>
    </Wrap>;
};
export default compose(pure)(ImportAnswers);